import template from './documentList.html';
import { DocumentListController } from './documentList.controller';

export const documentListComponent = {
  name: 'documentListComponent',
  restrict: 'E',
  template,
  controller: DocumentListController,
  controllerAs: 'vm',
  bindings: {
    inboxType: '='
  }
};
